export default function createIndex(content, options = {}) {
    const {
        spanClassIndex = "horse-name",
        indexElement = "book-index",
        alphabet = true,
    } = options;
    const items = content.querySelectorAll(`.${spanClassIndex}`);
    const grouped = {};
    let idNumber = 0;
    function normalizeName(name) {
        return name
            .toUpperCase()
            .replace(/\s*\(.*?\)/g, "")
            .replace(/\s+/g, " ")
            .trim();
    }

    items.forEach((item) => {
        idNumber += 1;
        const idElement = item.id;
        if (idElement === "") {
            item.id = "horse-" + idNumber;
        }
        const originalName = item.textContent.trim();
        const nameKey = normalizeName(originalName);
        const {id} = item;
        if (!nameKey || !id) {
            return;
        }

        if (!grouped[nameKey]) {
            grouped[nameKey] = new Set();
        }
        grouped[nameKey].add(id);
    });

    const sortedEntries = Object.entries(grouped).sort(([a], [b]) => a.localeCompare(b));

    const alphabetized = {};

    sortedEntries.forEach(([name, ids]) => {
        const letter = name[0].toUpperCase();
        if (!alphabetized[letter]) alphabetized[letter] = [];
        alphabetized[letter].push({name, ids: [...ids]});
    });

    const indexRoot = content.getElementById(indexElement);
    if (!indexRoot) return;

    indexRoot.innerHTML = ""; // clear previous

    const fragment = document.createDocumentFragment();

    Object.keys(alphabetized).sort().forEach((letter) => {
        const group = alphabetized[letter];
        const groupElement = document.createElement("div");
        groupElement.classList.add("alphabetical-index-list");

        const headerLine = document.createElement("div");
        headerLine.classList.add("header-line");
        groupElement.appendChild(headerLine);

        const header = document.createElement("h3");
        header.textContent = letter;
        groupElement.appendChild(header);

        const ul = document.createElement("ul");
        group.forEach(({name, ids}) => {
            const li = document.createElement("li");
            li.innerHTML = `<strong>${name}</strong> – ${ids.map(id => `<a href="#${id}"></a>`).join(", ")}`;
            ul.appendChild(li);
        });

        groupElement.appendChild(ul);
        fragment.appendChild(groupElement);
    });

    indexRoot.appendChild(fragment);
}
